import { useApplicationField } from '../useApplicationField';

// ─── Core ─────────────────────────────────────────────────────────────────────

export const useBorrowerLoanType = () =>
    useApplicationField(
        (d) => d.information.borrower.loanType,
        (d, v) => ({ ...d, information: { ...d.information, borrower: { ...d.information.borrower, loanType: v } } })
    );

export const useBorrowerLoanSubType = () =>
    useApplicationField(
        (d) => d.information.borrower.loanSubType,
        (d, v) => ({ ...d, information: { ...d.information, borrower: { ...d.information.borrower, loanSubType: v } } })
    );

export const useBorrowerIsFirstLoan = () =>
    useApplicationField(
        (d) => d.information.borrower.isFirstLoan,
        (d, v) => ({ ...d, information: { ...d.information, borrower: { ...d.information.borrower, isFirstLoan: v } } })
    );

export const useBorrowerShouldAskLegalQuestions = () =>
    useApplicationField(
        (d) => d.information.borrower.shouldAskLegalQuestions,
        (d, v) => ({ ...d, information: { ...d.information, borrower: { ...d.information.borrower, shouldAskLegalQuestions: v } } })
    );

export const useBorrowerUsingPmc = () =>
    useApplicationField(
        (d) => d.information.borrower.usingPropertyManagementCompany,
        (d, v) => ({ ...d, information: { ...d.information, borrower: { ...d.information.borrower, usingPropertyManagementCompany: v } } })
    );

export const useBorrowerHowDidYouHear = () =>
    useApplicationField(
        (d) => d.information.borrower.howDidYouHear,
        (d, v) => ({ ...d, information: { ...d.information, borrower: { ...d.information.borrower, howDidYouHear: v } } })
    );

export const useBorrowerFirstLoanWithBfi = () =>
    useApplicationField(
        (d) => d.information.borrower.firstLoanApplicationWithBfi,
        (d, v) => ({ ...d, information: { ...d.information, borrower: { ...d.information.borrower, firstLoanApplicationWithBfi: v } } })
    );

export const useBorrowerBuildRentTypeId = () =>
    useApplicationField(
        (d) => d.information.borrower.buildRentTypeId,
        (d, v) => ({ ...d, information: { ...d.information, borrower: { ...d.information.borrower, buildRentTypeId: v } } })
    );

export const useBorrowerMasterNoteId = () =>
    useApplicationField(
        (d) => d.information.borrower.masterNoteId,
        (d, v) => ({ ...d, information: { ...d.information, borrower: { ...d.information.borrower, masterNoteId: v } } })
    );
